<style lang="scss" scoped>
.admin-page {
    height: 100vh;
    display: flex;

    .container-navbar {
        height: calc(100% - 68px);
        overflow-y: auto;
        overflow-x: hidden;
    }
    .content {
        height: 100%;
        width: 100%;
    }
    ::v-deep .sleeping_salamander_svg__sleeping-z-small {
        animation: hideshow 3s ease infinite;
    }
    ::v-deep .sleeping_salamander_svg__sleeping-z-big {
        animation: hideshow 3s ease infinite;
        animation-delay: 0.3s
    }

    @keyframes hideshow {
        0% {
            opacity: 0;
            transform: scale(1);
        }

        50% {
            opacity: 1;
            transform: scale(1.05);
        }

        95% {
            opacity: 0;
            transform: scale(1);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    }
}
</style>

<template>
    <div class="admin-page">
        <div class="content">
            <template v-if="isValid">
                <admin-navbar></admin-navbar>

                <router-view class="container-fluid container-navbar" :key="$route.path"></router-view>
            </template>
            <template v-else>
                <div class="container h-100">
                    <div class="row h-100">
                        <div class="col-auto m-auto text-center">
                            <template v-if="!currentUser.user && currentUser.psychologist && currentUser.psychologist.status === 'pending'">
                                <image-sleeping height="300"></image-sleeping>
                                <h4 class="text-primary-dark fw-b text-center mt-32">{{ $t('errors.no_psychologist_access') }}</h4>
                                <p class="text-center w-75 mx-auto">{{ $t('errors.no_psychologist_access_desc') }}</p>
                            </template>
                            <template v-else>
                                <image-no-access height="300"></image-no-access>
                                <h4 class="text-primary-dark fw-b text-center mt-32">{{ $t('errors.no_admin_access') }}</h4>
                                <p class="text-center">{{ $t('errors.no_admin_access_desc') }}</p>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
import { adminNavbar } from '@/components/layouts/'

export default {
    components: { adminNavbar },

    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        isValid() {
            // TODO Psychologists should also have permissions? 
            return this.currentUser.permissions.some((v) => ['medical_info.read', 'personal_info.read', 'sleep_info.read', 'sleep_schedule.read', 'habit.read'].indexOf(v) !== -1) || (this.currentUser.psychologist && this.currentUser.psychologist.status === 'approved')
        }
    }
}
</script>
